import { apiGet, apiPost, apiPatch } from './index'

// 发布帖子 -- 上传图片，附件
const uploadPathFile = (params) => apiPost(`/api/sys-files/uploadPathFile`, params, true)

// 新增帖子
const addPost = (params) => apiPost(`/api/area-postbar`, params)

// 编辑帖子
const updatePost = (params) => apiPost(`/api/area-postbar/update/${params.id}`, params)

// 专区 - 帖子列表
const postList = (params) => apiGet(`/api/area-postbar/listPagePhone/${params.areaId}`, params)

// 专区 - 主题列表
const subjectList = (params) => apiGet(`/api/area/subject/mobile`, params)

// 专区 - 报名详情
const signDetails = (params) => apiGet(`/api/area/enroll/${params.areaId}`)

// 专区 - 报名
const confirmSign = (params) => apiPost(`/api/area/student`, params)

// 专区 - 取消报名
const cancelSign = (params) => apiPost(`/api/area/student/quit`, params)

// 专区 - 信息统计
const getZones = (params) => apiGet(`/api/area/compute/${params.areaId}`)

// 专区 - 点赞
const postLike = (params) => apiPost(`/api/area/like`, params)
// 普通 - 取消点赞
const cancelLike = (params) => apiPost(`/api/area/like/cancel/${params.userId}/${params.baseId}`, params)

// 专区 - 取消点赞
const delLike = (params) => apiPost(`/api/area/like/delete/${params.id}`)

// 专区 - 获取专区的角色信息
const roleDetails = (params) => apiGet(`/api/area/role/${params.areaId}/${params.userId}`)

// 专区 - 帖子详情
const postDetails = (params) => apiGet(`/api/area-postbar/${params.postbarId}`)

// 专区 - 帖子评论
const commentApi = (params) => apiPost(`/api/area/comment`, params)

// 专区 - 评论列表
const getCommentDefaultList = (params) => apiGet(`/api/area/comment/getCommentDefaultList`, params)

// 专区 - 根据返回id获取附件内容
const filesInfo = (params) => apiGet(`/api/sys-files/selectList/${params.mainId}`)

// 专区 - 根据返回id获取素材库内容
const selectStock = (params) => apiGet(`/api/materials/${params.mainId}`)

// 专区 - 导师列表
const selectUsers = (params) => apiGet(`/api/johnson/iep/users`, params)
// api/?realName=&pageNum=1&pageSize=10&memberType=0&hospitalId=MDMC3001344

// 专区 - 导师
const selectAreaUsers = (params) => apiGet(`/api/area/tutor/${params.areaId}`, params)

// 专区 - 提交作业
const answerWork = (params) => apiPost(`/api/area-postbar-work`, params)

// 专区 - 作业详情
const workDetails = (params) => apiGet(`/api/area-postbar-work/findByIdPhone/${params.workId}`)

// 专区 - 提交作业列表
const apiWorkList = (params) => apiGet(`/api/area-postbar-work/listPagePhone/${params.postbarId}`, params)

// 专区 - 审批作业
const correctWork = (params) => apiPatch(`/api/area-postbar-work/${params.workId}`, params)

// 专区 - 编辑回答作业
const updateAnswerWork = (params) => apiPost(`/api/area-postbar-work/update/${params.workId}`, params)

// 专区 - 直播预告
const getMmeeting = (params) => apiGet(`/api/area/meeting`, params)

// 保存用户浏览专区
const zoneUserVisit = (params) => apiPost(`/api/area/user/visit`, params)

// 获取用户上次浏览的专区id
const zoneUserVisitId = (params) => apiGet(`/api/area/user/visit/${params.userId}/${params.memberType}`)

// 获取最近一场直播
const getMeetingHome = (params) => apiGet(`/api/area/meeting/recently/${params.userId}`)

// 投票
const votePostSelected = (params) => apiPost(`/api/area/postbar/voteselect/selected`, params)

// 专区详情背景图
const zoneDetailsImg = (params) => apiGet(`/api/area/detail/backdrop/pic/${params.areaId}`, params)

// 专区点击视频播放得时候
const visitAdd = (params) => apiPost(`/api/area-postbar/visitAdd`, params)

// ppt 转 pdf
const pptranscoding = (params) => apiPost(`/api/area-postbar-work/pptranscoding`, params)

// /    get置顶接口，参数：id 传评论id，isTop  传1置顶0撤销置顶
const commentUserTop = (params) => apiGet(`/api/area/comment/userTop`, params)

// 研修营列表
const getTrainingCampList = (params) => apiGet(`/api/area/trainingcamp/list`, params)

// 研修营详情
const getTrainingCampDetail = (params) => apiGet(`/api/area/trainingcamp/mobile/${params.id}`, params)

// 研修营tab数据
const getTrainingCampTabData = (params) => apiPost(`/api/area/trainingcamp/mobile/info`, params)

export {
  uploadPathFile,
  postList,
  addPost,
  subjectList,
  signDetails,
  confirmSign,
  cancelSign,
  getZones,
  postLike,
  cancelLike,
  delLike,
  roleDetails,
  postDetails,
  commentApi,
  getCommentDefaultList,
  filesInfo,
  selectStock,
  selectUsers,
  selectAreaUsers,
  answerWork,
  workDetails,
  apiWorkList,
  correctWork,
  updateAnswerWork,
  updatePost,
  getMmeeting,
  zoneUserVisit,
  zoneUserVisitId,
  getMeetingHome,
  votePostSelected,
  zoneDetailsImg,
  visitAdd,
  pptranscoding,
  commentUserTop,
  getTrainingCampList,
  getTrainingCampDetail,
  getTrainingCampTabData
}



// WEBPACK FOOTER //
// ./src/api/zone.js